import { type FC } from 'react';

import { Typography } from 'enable-ui';

import { COLOR, COLOR_CONFIG } from 'constants/color';

export const FunctionalAbilityResult: FC<{
  title: string;
  createdAt: string;
  score: number;
  handleViewHistory: () => void;
  handleViewDetailHistory: () => void;
}> = ({ title, createdAt, score, handleViewHistory, handleViewDetailHistory }) => {
  const isResult = createdAt ? true : false;

  return (
    <div
      style={{
        border: '1px solid #00000040',
        borderRadius: 12,
        padding: '16px',
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        alignSelf: 'stretch',
        cursor: 'pointer',
      }}
      onClick={handleViewDetailHistory}
    >
      <div style={{ width: 'calc(100% - 68px)' }}>
        <Typography
          variant="body-2"
          color={COLOR.surfaceNeutralBold['neutral-11']}
          style={{
            whiteSpace: 'nowrap',
          }}
          weight={500}
        >
          {title}
        </Typography>
        {createdAt && (
          <Typography variant="paragraph" color={COLOR_CONFIG['neutral-text']}>
            {createdAt}
          </Typography>
        )}
        {isResult ? (
          <Typography
            variant="body-3"
            weight={600}
            style={{ marginTop: 14, cursor: 'pointer' }}
            color={COLOR.purpel['purpel-6']}
            onClick={(e) => {
              e.stopPropagation();
              handleViewHistory();
            }}
          >
            View history
          </Typography>
        ) : null}
      </div>
      <div
        style={{
          width: 52,
          height: 52,
          borderRadius: '50%',
          border: `1px solid ${isResult ? COLOR.primary['primary-3'] : COLOR.neutralTrans['neutralTrans-15']}`,
          background: isResult ? COLOR.primary['primary-1'] : COLOR.neutral['neutral-2'],
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Typography
          variant={isResult ? 'body-3' : 'paragraph'}
          style={{
            color: isResult ? COLOR.primary['primary-6'] : COLOR_CONFIG['neutral-text'],
            textAlign: 'center',
          }}
          weight={500}
        >
          {isResult ? score : 'No result'}
        </Typography>
      </div>
    </div>
  );
};
